jQuery(document).ready(function($){

  setTimeout(()=>{
    var rating = jQuery('.stamped-badge').attr('data-rating');
    if( rating != undefined ){
    $('span.stamped-product-reviews-badge.stamped-main-badge').prepend('<span class="rating_num">'+rating+'</span>'); }
  }, 6000 );
  
  $(document.body).on('change', '[name="packsub"]', function() {
    var selectedValue = $(this).val();
    
    // Get the JSON data from the script tag
    var jsonData = $('variant-radios script').html().trim();
    
    // Parse the JSON data
    var items = JSON.parse(jsonData);
    
    // Find the item with the matching title
    var exploreItem = items.find(item => item.title === selectedValue);
    var exploreItemprice = items.find(item => item.price === selectedValue);
    
    
    // Check if the item was found
    if (exploreItem) {
        // Assuming exploreItem has an id or some unique identifier
        var exploreItemID = exploreItem.id; // Change this to the correct property
      $('#productID').val(exploreItemID)
    }
    setTimeout(()=>{
      var vvprice = $('span.appstle_subscription_amount.transcy-money').html();
      $('.pdp_detail .pdp-price strong').html(vvprice);
    },400);
});
});

class VariantSelects extends HTMLElement {
  constructor() {
    super(), this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions(),
      this.updateMasterId(),
      this.toggleAddButton(!0, "", !1),
      this.updatePickupAvailability(),
      this.removeErrorMessage(),
      this.currentVariant
        ? (this.updateURL(),
          this.updateVariantInput(),
          this.renderProductInfo())
        : (this.toggleAddButton(!0, "", !0), this.setUnavailable());
  }
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (variant) =>
        !variant.options
          .map((option, index) => this.options[index] === option)
          .includes(!1)
    );
  }
  updateURL() {
      // Check if currentVariant is falsy or updateUrl is "false"
      if (!this.currentVariant || this.dataset.updateUrl === "false") {
          return; // Exit the function early
      }
  
      // Update the product selector value
      jQuery("#product_selector, #productselector").val(this.currentVariant.id);
      
      // Uncomment if you want to trigger a click on the featured image
      // jQuery('[data-id="' + this.currentVariant.featured_image.id + '"]').trigger("click");
      // console.log(this.currentVariant);
      if( this.currentVariant.available == true ){
        jQuery('button[name="add"]').prop('disabled', false);
            jQuery('button[name="add"] span').text('Add to Cart');
      }else{
        jQuery('button[name="add"]').prop('disabled', true);
            jQuery('button[name="add"] span').text('Sold Out');
      }
      // Update the product ID
      jQuery('#productID').val(this.currentVariant.id); // Fixed typo here
      jQuery('#vbox-'+this.currentVariant.id).show().siblings().hide();

      // Update the URL in the browser's address bar
      window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    document
      .querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
      )
      .forEach((productForm) => {});
  }
  updatePickupAvailability() {
    this.currentVariant && this.currentVariant.available
      ? (jQuery(".stockStutus").text("In Stock"),
        jQuery(".stockStutus").removeClass("unavailable"))
      : (jQuery(".stockStutus").text("Out Of Stock"),
        jQuery(".stockStutus").addClass("unavailable"));
  }
  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;
    const productForm = section.querySelector("product-form");
    productForm && productForm.handleErrorMessage();
  }
  renderProductInfo() {
    console.log(this.currentVariant);
    var vprice = Shopify.formatMoney(this.currentVariant.price);
    jQuery(".pdp-price strong, #ontime_txt").text(vprice);
    var original_price = vprice.replace("$", ""),
      subscribepice = (original_price * 10) / 100,
      total = original_price - subscribepice;
    $("#lw_subtotal_price").text("$" + total.toFixed(2)),
      $("#txt_btn").html("<del>" + vprice + "</del> $" + total.toFixed(2)),
      this.currentVariant.compare_at_price > this.currentVariant.price
        ? (jQuery(".pdp-price span.actual-price").text(
            Shopify.formatMoney(this.currentVariant.compare_at_price)
          ),
          jQuery(".pdp-price").addClass("sale"))
        : (jQuery(".pdp-price span.actual-price").text(""),
          jQuery(".pdp-price").removeClass("sale"));
  }
  toggleAddButton(disable = !0, text, modifyClass = !0) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('button[name="add"]'),
      addButtonText = productForm.querySelector('button[name="add"] > span');
    addButton &&
      (disable
        ? (jQuery(".addtocart-btn").addClass("sold-out"),
          text && (addButtonText.textContent = text))
        : (jQuery(".addtocart-btn").removeClass("sold-out"),
          (addButtonText.textContent = window.variantStrings.addToCart)));
  }
  setUnavailable() {
    const button = document.getElementById(
        `product-form-${this.dataset.section}`
      ),
      addButton = button.querySelector('[name="add"]'),
      addButtonText = button.querySelector('[name="add"] > span'),
      price = document.getElementById(`price-${this.dataset.section}`);
    addButton &&
      ((addButtonText.textContent = window.variantStrings.unavailable),
      price && price.classList.add("visibility-hidden"));
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector('[type="application/json"]').textContent
        )),
      this.variantData
    );
  }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("div"));
    this.options = fieldsets
      .map((fieldset) => {
        const select = fieldset.querySelector("select");
        if (select) {
          const selectedOption = Array.from(select.options).find(
            (option) => option.selected
          );
          return selectedOption ? selectedOption.value : null;
        }
        return null;
      })
      .filter((value) => value !== null); 

  }
}
customElements.define("variant-radios", VariantRadios);
